<div class="card">
  <div class="card-body p-4">
    <div class="container col-sm-4 text-center">
      <br />

      <img class="rounded" src="{{ getDocThumbnail(form.data['imageId']) }}" height="200px"
        (error)="onImageError($event,'assets/images/icons/user1.png')" (click)="file.click()"
        style="cursor: pointer;" [alt]="'profile.image.alt' | translate" 
        [title]="'profile.image.upload' | translate" />
      <input #file type="file" accept="image/*" style="display: none"
        (change)="onFileChanged(file.files && file.files[0])" />
      <br />
      <div class="row mt-2" style="justify-content: center">
        {{ form.data["loginId"] }}
      </div>
    </div>
    <br />
    <div class="container border col-sm-8">
      <div class="row border-bottom">
        <div class="col">
          <h4 class="modal-title">{{ 'profile.title' | translate }}</h4>
        </div>
        <div class="col d-flex flex-row-reverse">
          <button type="button" class="btn btn-outline-primary btn-sm ms-2 my-1" (click)="updateProfile()"
            [disabled]="!profileForm.valid">
            <i class="fa fa-save"></i> {{ 'profile.buttons.save' | translate }}
          </button>
        </div>
      </div>
      <form class="form-horizontal" role="form" #profileForm="ngForm">
        <p>
          <form-error [form]="form"></form-error>
        </p>
        <div class="form-group form-row">
          <label for="firstName" class="col-form-label col-form-label-sm">
            {{ 'profile.form.labels.firstName' | translate }}
          </label>
          <div class="col">
            <input required [(ngModel)]="form.data['firstName']" name="firstName" type="text"
              pattern="[a-zA-Z][a-zA-Z ]+" class="form-control form-control-sm" id="firstName"
              [placeholder]="'profile.form.placeholders.firstName' | translate" />
            <span style="color: red">{{ form.inputerror["firstName"] }} </span>
          </div>
          <label for="lastName" class="col-form-label col-form-label-sm">
            {{ 'profile.form.labels.lastName' | translate }}
          </label>
          <div class="col">
            <input required [(ngModel)]="form.data['lastName']" class="form-control" name="lastName" type="text"
              pattern="[a-zA-Z][a-zA-Z ]+" class="form-control form-control-sm" id="lastName"
              [placeholder]="'profile.form.placeholders.lastName' | translate" />
          </div>
        </div>
        <div class="form-group form-row">
          <label for="gender" class="col-sm-1 col-form-label col-form-label-sm">
            {{ 'profile.form.labels.gender' | translate }}
          </label>
          <div class="col">
            <select required class="form-select form-select-sm" [(ngModel)]="form.data['gender']" name="gender"
              id="gender">
              <option>{{ 'profile.form.genderOptions.male' | translate }}</option>
              <option>{{ 'profile.form.genderOptions.female' | translate }}</option>
            </select>
          </div>
          <label for="dob" class="col-sm-1 col-form-label col-form-label-sm">
            {{ 'profile.form.labels.dob' | translate }}
          </label>
          <div class="col">
            <input class="form-control form-control-sm" type="date" #myDate
              [value]="form.data['dob'] | date : 'yyyy-MM-dd'" (input)="form.data['dob'] = parseDate($event)" />
          </div>
        </div>
        <div class="form-group form-row">
          <label for="email" class="col-sm-1 col-form-label col-form-label-sm">
            {{ 'profile.form.labels.email' | translate }}
          </label>
          <div class="col">
            <input type="text" [pattern]="emailPattern" class="form-control form-control-sm"
              [(ngModel)]="form.data['email']" name="email" id="email" 
              [placeholder]="'profile.form.placeholders.email' | translate" required
              #email="ngModel" />
            <div *ngIf="email.errors && !iseValidFormSubmitted" [ngClass]="'error'">
              <div *ngIf="email.errors['pattern']">
                <strong style="color: red">{{ 'profile.form.errors.email' | translate }}</strong>
              </div>
            </div>
          </div>
          <label for="phone" class="col-sm-1 col-form-label col-form-label-sm">
            {{ 'profile.form.labels.phone' | translate }}
          </label>
          <div class="col">
            <input
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              type="number" [pattern]="mobNumberPattern" class="form-control form-control-sm" id="phone" name="phone"
              [(ngModel)]="form.data['phone']" [placeholder]="'profile.form.placeholders.phone' | translate" 
              maxlength="10" minlength="10" required
              title="Please enter valid phone number" #phone="ngModel" />
            <div *ngIf="phone.errors && !isValidFormSubmitted" [ngClass]="'error'">
              <div *ngIf="phone.errors['pattern']">
                <strong style="color: red">{{ 'profile.form.errors.phone' | translate }}</strong>
              </div>
            </div>
            <span style="color: red">{{ form.inputerror["phone"] }} </span>
          </div>
        </div>

        <div class="form-group form-row">
          <label for="alternateMobile" class="col-form-label col-form-label-sm">
            {{ 'profile.form.labels.alternateMobile' | translate }}
          </label>
          <div class="col">
            <input [(ngModel)]="form.data['alternateMobile']" name="alternateMobile" type="text"
              class="form-control form-control-sm" id="alternateMobile" 
              [placeholder]="'profile.form.placeholders.alternateMobile' | translate" />
            <span style="color: red">{{ form.inputerror["alternateMobile"] }}
            </span>
          </div>
          <label for="mobileId" class="col-form-label col-form-label-sm">
            {{ 'profile.form.labels.mobileId' | translate }}
          </label>
          <div class="col">
            <input [(ngModel)]="form.data['mobileId']" name="mobileId" type="text" class="form-control form-control-sm"
              id="mobileId" [placeholder]="'profile.form.placeholders.mobileId' | translate" />
            <span style="color: red">{{ form.inputerror["mobileId"] }} </span>
          </div>
        </div>
      </form>
    </div>
    <br />
    <div class="container border col-sm-8">
      <div class="row border-bottom">
        <div class="col">
          <h4 class="modal-title">{{ 'profile.password.title' | translate }}</h4>
        </div>
        <div class="col d-flex flex-row-reverse">
          <button type="button" class="btn btn-outline-primary btn-sm ms-2 my-1" (click)="changePassword()"
            [disabled]="!cppForm.valid">
            <i class="fa fa-save"></i> {{ 'profile.buttons.save' | translate }}
          </button>
        </div>
      </div>
      <form class="form-horizontal" role="cpForm" #cppForm="ngForm">
        <p>
          <form-error [form]="cpForm"></form-error>
        </p>
        <div class="row">
          <div class="form-group form-row">
            <label for="default" class="col-sm-1.5 col-form-label col-form-label-sm">
              {{ 'profile.password.labels.oldPassword' | translate }}
            </label>
            <div class="col-sm-7">
              <input required [(ngModel)]="cpForm['oldPassword']" name="oldPassword" type="password"
                class="form-control form-control-sm" id="oldPassword" 
                [placeholder]="'profile.password.placeholders.oldPassword' | translate" />
              <span style="color: red">{{ cpForm.inputerror["oldPassword"] }}
              </span>
            </div>
          </div>
          <div class="form-group form-row">
            <label for="date" class="col-sm-1.5 col-form-label col-form-label-sm">
              {{ 'profile.password.labels.newPassword' | translate }}
            </label>
            <div class="col-sm-7">
              <input required [(ngModel)]="cpForm['newPassword']" class="form-control" name="newPassword"
                type="password" class="form-control form-control-sm" id="newPassword"
                [placeholder]="'profile.password.placeholders.newPassword' | translate" />
              <span style="color: red">{{ cpForm.inputerror["newPassword"] }}
              </span>
            </div>
          </div>

          <div class="form-group form-row">
            <label for="password" class="col-sm-1.5 col-form-label col-form-label-sm">
              {{ 'profile.password.labels.confirmPassword' | translate }}
            </label>
            <div class="col-sm-7 mb-2">
              <input required [(ngModel)]="cpForm['confirmPassword']" name="confirmPassword" type="password"
                class="form-control form-control-sm" id="confirmPassword" 
                [placeholder]="'profile.password.placeholders.confirmPassword' | translate" />
              <span style="color: red">{{ cpForm.inputerror["confirmPassword"] }}
              </span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>